"use strict";

class QPortfolioMenu {
    constructor(elementId, config) {
        /** @type {JQuery<HTMLElement>} */ this._element = $(`#${elementId}`);

        if (!this._element || !config.menuConfig.products.length) return {};

        this._menuConfig = config.menuConfig;

        this._build();
    }

    _build() {
        this._element.append(this._buildWrapper());
    }

    _buildWrapper() {
        const wrapper = $(`<div class="dropdown w-100">`).css('height', '16px');
        const button = this._buildButton();
        const dropdown = this._buildDropdown();

        wrapper.append(button, dropdown);

        return wrapper;
    }

    _buildButton() {
        return $(/*html*/`<button class="dropdown-toggle w-100 border-0 p-0" style="height: 16px" data-toggle="dropdown"></button>`);
    }

    _buildDropdown() {
        const dropdown = $(/*html*/`
            <div class="dropdown-menu dropdown-menu-lg py-5" x-placement="bottom-start">
				<ul class="navi"></ul>
			</div>
        `);

        const withAccess = []; 
        const withoutAccess = [];
        
        this._menuConfig.products.forEach((product) => {
            if (product.hasAccess) withAccess.push(product);
            else withoutAccess.push(product);
        });

        dropdown
            .find('ul')
            .append(this._withAccessItems(withAccess));

        if (withoutAccess.length) {
            dropdown
                .find('ul')
                .append(this._withoutAccessItems(withoutAccess));
        }

        return dropdown;
    }

    _withAccessItems(items) {
        return [
            $(/*html*/`<li class="navi-section text-primary font-weight-bolder pb-0 pl-4">Ir para</li>`),
            ...items.map((item) => this._itemTemplate(item)) 
        ];
    }

    _withoutAccessItems(items) {
        return [
            $(/*html*/`<li class="navi-separator m-4"></li>`),
            $(/*html*/`<li class="navi-section mt-5 text-primary font-weight-bolder pb-0 pl-4">Descobrir</li>`),
            ...items.map((item) => this._itemTemplate(item)) 
        ];
    }

    _itemTemplate(item) {
        return $(/*html*/ `
            <li class="navi-item">
                <a class="navi-link px-6" href="${item.url || ''}" target="_blank">
                    <span class="navi-icon">
                        <i class="las ${item.icon}"></i>
                    </span>
                    <div class="navi-text">
                        <span class="d-block">${item.name}</span>
                        <span class="d-block product-caption">${item.caption || ''}</span>
                    </div>
                </a>
            </li>
        `);
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = QPortfolioMenu;
}